type videoTypeType = 'youtube' | 'vimeo';

export function videoType(str: string): videoTypeType {
  if (str) {
    if (youtubeId(str)) {
      return 'youtube';
    }
    if (vimeoId(str)) {
      return 'vimeo';
    }
  }
  return null;
}

export function youtubeId(str: string): string {
  /* UPD @see https://stackoverflow.com/questions/71000139/javascript-regex-for-youtube-video-and-shorts-id */
  const youtubeRegexp = new RegExp('(youtu.*be.*)\\/(watch\\?v=|embed\\/|v|shorts|)(.*?((?=[&#?])|$))', 'gm');
  const matches = youtubeRegexp.exec(str);
  return matches ? matches[3] : null;
}

export function youtubeEmbedUrl(str: string): string {
  const id = youtubeId(str);
  return id ? `https://www.youtube.com/embed/${id}` : null;
}

export type YoutubeCoverImageSize = 'maxresdefault' | 'hqdefault' | 'mqdefault';

export function youtubeCoverImageUrl(str: string, size: YoutubeCoverImageSize = 'mqdefault'): string {
  // https://stackoverflow.com/questions/2068344/how-do-i-get-a-youtube-video-thumbnail-from-the-youtube-api
  const id = youtubeId(str);
  // грязный способ
  return id ? `https://img.youtube.com/vi/${id}/${size}.jpg` : null;
}

export function vimeoId(str: string): string {
  /* @see https://stackoverflow.com/a/41209591/3544196 */
  const vimeoRegexp = new RegExp(
    '^(?:(https?:)?\\/\\/)?(?:www\\.|player\\.)?vimeo.com\\/(?:channels\\/(?:\\w+\\/)?|groups\\/(?:[^\\/]*)\\/videos\\/|album\\/(?:\\d+)\\/video\\/|video\\/|)(\\d+)(?:[a-zA-Z0-9_\\-]+)?$',
    'igm',
  );

  const matches = vimeoRegexp.exec(str);
  return matches ? matches[2] : null;
}

export function vimeoEmbedUrl(str: string): string {
  const id = vimeoId(str);
  return id ? `https://player.vimeo.com/video/${id}?color=ff9933` : null;
}

export function vimeoCoverImageUrl(str: string, size?: any): string {
  // https://stackoverflow.com/questions/1361149/get-img-thumbnails-from-vimeo
  const id = vimeoId(str);
  return id ? `https://i.vimeocdn.com/video/${id}.png?mw=1540&mh=820&q=70` : null; // грязный способ
}
